import { render, staticRenderFns } from "./ProductPrice.vue?vue&type=template&id=735e7104"
import script from "./ProductPrice.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductPrice.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports